import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { UserProvider } from './context/UserContext';
import PrivateRoute from './routes/PrivateRoute';
import AdminRoute from './routes/AdminRoute';
import RedirectIfAuthenticated from './routes/RedirectIfAuthenticated';
import ATCComponent from './components/ATCComponent';
import LustPage from './components/LustPage';
import './App.css';
import Login from './components/Login';
import Welcome from './components/Welcome';
import RecoverPassword from './components/RecoverPassword';
import ResetPassword from './components/ResetPassword';
import UploadIne from './components/UploadIne';
import CreateAccount from './components/CreateAccount';
import FinishOnboarding from './components/FinishOnboarding';
import ConsignorLanding from './components/ConsignorLanding';
import MainLayout from './components/MainLayout';
import HomeDashboard from './components/HomeDashboard';
import AdminInventoryPage from './components/AdminInventoryPage';
import AdminAddInventoryPage from './components/AdminAddInventoryPage';
import AdminPhotoQueuePage from './components/AdminPhotoQueuePage';
import AdminCleaningQueuePage from './components/AdminCleaningQueuePage';
import AdminProductSalesPage from './components/AdminProductSalesPage';
import AdminConsignorsPage from './components/AdminConsignorsPage';
import AdminConsignorPaymentsPage from './components/AdminConsignorPaymentsPage';
import AdminHomePage from './components/AdminHomePage';
import ConsignorInventoryPage from './components/ConsignorInventoryPage';
import ConsignorSalesPage from './components/ConsignorSalesPage';
import ConsignorProfilePage from './components/ConsignorProfilePage';
import {
  ADMIN_CLEANING_QUEUE_PATH,
  ADMIN_CONSIGNORS_PATH,
  ADMIN_HOME_PATH,
  ADMIN_INVENTORY_ADD_PATH,
  ADMIN_INVENTORY_PATH,
  ADMIN_PAYMENTS_PATH,
  ADMIN_PHOTO_QUEUE_PATH,
  ADMIN_SALES_PATH,
  CONSIGNOR_INVENTORY_PATH,
  CONSIGNOR_SALES_PATH,
  CONSIGNOR_PROFILE_PATH,
  RECOVER_PASSWORD_PATH,
  RESET_PASSWORD_TOKEN_PATH,
  FINISH_ONBOARDING_PATH,
  CONSIGNOR_LANDING_PATH,
} from './routes/routePaths';

const theme = createTheme({
  palette: {
    mode: 'light',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <UserProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route
                path="/urban"
                element={
                  <div style={{ padding: '20px', textAlign: 'center' }}>
                    <h1>Urban Consignment Frontend</h1>
                    <p>Bienvenido a la aplicación ATC (Agregar al Carrito)</p>
                    <p>Navega a /atc?atc=TU_DATO_BASE64 para usar la función ATC</p>
                  </div>
                }
              />
              <Route path="/atc" element={<ATCComponent />} />
              <Route path="/lust" element={<LustPage />} />
              <Route path={CONSIGNOR_LANDING_PATH} element={<ConsignorLanding />} />
              <Route element={<RedirectIfAuthenticated />}>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<Welcome />} />
                <Route path="/create-account" element={<CreateAccount />} />
                <Route path={RECOVER_PASSWORD_PATH} element={<RecoverPassword />} />
                <Route path={RESET_PASSWORD_TOKEN_PATH} element={<ResetPassword />} />
                <Route path={FINISH_ONBOARDING_PATH} element={<FinishOnboarding />} />
              </Route>
              <Route element={<PrivateRoute />}>
                <Route path="/upload-ine" element={<UploadIne />} />
                <Route element={<MainLayout />}>
                  <Route path="/home" element={<HomeDashboard />} />
                  <Route path={CONSIGNOR_INVENTORY_PATH} element={<ConsignorInventoryPage />} />
                  <Route path={CONSIGNOR_SALES_PATH} element={<ConsignorSalesPage />} />
                  <Route path={CONSIGNOR_PROFILE_PATH} element={<ConsignorProfilePage />} />
                  <Route element={<AdminRoute />}>
                    <Route path="/admin" element={<Navigate to={ADMIN_HOME_PATH} replace />} />
                    <Route path={ADMIN_HOME_PATH} element={<AdminHomePage />} />
                    <Route path={ADMIN_INVENTORY_ADD_PATH} element={<AdminAddInventoryPage />} />
                    <Route path={ADMIN_INVENTORY_PATH} element={<AdminInventoryPage />} />
                    <Route path={ADMIN_SALES_PATH} element={<AdminProductSalesPage />} />
                    <Route path={ADMIN_PHOTO_QUEUE_PATH} element={<AdminPhotoQueuePage />} />
                    <Route path={ADMIN_CLEANING_QUEUE_PATH} element={<AdminCleaningQueuePage />} />
                    <Route path={ADMIN_CONSIGNORS_PATH} element={<AdminConsignorsPage />} />
                    <Route path={ADMIN_PAYMENTS_PATH} element={<AdminConsignorPaymentsPage />} />
                  </Route>
                </Route>
              </Route>
            </Routes>
          </div>
        </Router>
      </UserProvider>
    </ThemeProvider>
  );
}

export default App;
